<template>
  <el-dropdown trigger="click" @command="handleCommand" :hide-on-click="false" class="collection-edit-list-dropdown"
    popper-class="custom-menu-edit-popover-class">
    <span class="dropdown-trigger">
      <slot />
    </span>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item v-if="collectionPermission ===100 && !props.row?.curation_id ">
          <el-popover class="box-item" placement="right" popper-class="custom-menu-popover-class"
            v-model:visible="popoverVisible">
            <template #reference>
              <p class="had-more">Change status<span><svg-icon name="arrow" /></span></p>
            </template>
            <template #default>
              <el-dropdown-item command="active">
                <p :class="['status-p', disabledActive && 'disabled-status-p']">Active<svg-icon
                    v-if="props.is_published && props.row" name="yes-2" /></p>
              </el-dropdown-item>
              <!-- diasbled can had two status, so always show disable -->
              <el-dropdown-item command="disable">
                <p :class="['status-p']">Disable<svg-icon v-if="!props.is_published && props.row" name="yes-2" /></p>
              </el-dropdown-item>
            </template>
          </el-popover>
        </el-dropdown-item>

        <el-dropdown-item command="flag" v-if="!props.row?.curation_id ">Flag this page</el-dropdown-item>
        <el-dropdown-item command="view" v-if="props.row && !props.row.is_disabled && !props.row.is_hidden && !props.row.is_archvied ">View live</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script setup>

import { ref, watch, getCurrentInstance, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import moment from 'moment';
import Store from '@/store/index.js';
import { ElDropdown, ElDropdownMenu, ElDropdownItem, ElPopover, ElButton } from 'element-plus';

const router = useRouter();
const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;

const props = defineProps({
  row: {
    type: Object,
    default: null
  },
  is_published: {
    type: Boolean,
    default: false
  },
  data: {
    type: Array,
    default: []
  }
});

const popoverVisible = ref(false)
const disabledActive = computed(() => {
  // 如果是 row 並且 is_published 為 true，則禁用 active
  if (props.row && props.is_published) {
    return true;
  }
  // 如果是 data 並且所有項目都已active，則禁用 active
  if (!props.row && props.data.filter(e => e.is_selected).every(item => !item.is_disabled && !item.is_hidden && !item.is_archvied)) {
    return true;
  }
  return false;
});

const disabledDisable = computed(() => {
  // 如果是 row 並且 is_published 為 false，則禁用 disable
  if (props.row && !props.is_published) {
    return true;
  }
  // 如果是 data 並且所有項目都disable或hidden，則禁用 disable
  if (!props.row && props.data.filter(e => e.is_selected).every(item => item.is_disabled || item.is_hidden && item.is_archvied)) {
    return true;
  }
  return false;
});

const collectionPermission = computed(() => {
  //50 can view /0 can not view/100 all can view can edit
  return store.state.user_data.permission_list?.contentModeration?.contentModeration?.permission;
});
 //only collectionPermission now
// const disabledPermission = computed(() => {
//   return store.state.user_data.permission_list?.contentModeration?.canDisableContent?.permission;
// });

// const flagPermission = computed(() => {
//   return store.state.user_data.permission_list?.contentModeration?.canFlagContent?.permission;
// });
//++++++++++++++++++++++++++++++++++++++++++++++
const handleCommand = (command) => {
  // 關掉 popover
  popoverVisible.value = false;
  let dataValue = props.row ? [{ ...props.row }] : props.data.filter(e => e.is_selected);
  console.log('dataValue', dataValue);
  switch (command) {

    case 'active':
      if (disabledActive.value) {
        return;
      }
      eventBus.emit('open-collection-handle-dialog', { id: 2, rows: dataValue, which: dataValue[0].type });
      return;
    case 'disable':
      eventBus.emit('open-collection-handle-dialog', { id: 1, rows: dataValue, which: dataValue[0].type });
      return;
    case 'flag':
      eventBus.emit('open-collection-handle-dialog', { id: 3, rows: dataValue, which: dataValue[0].type });
      return;
    case 'view':
      window.open(props.row.share_url, '_blank');
      return;
    default:
  }
  // 做你要的事
  console.log('選擇狀態：', command)
}
onMounted(() => { });

</script>

<style lang="scss">
.custom-menu-edit-popover-class {
  .el-dropdown-menu {
    padding: 8px 0 !important;
  }

  .el-dropdown-menu__item {
    border-radius: 0 !important;

    &:hover {
      background-color: var(--black-40);
      transition: .3s;
    }
  }

  .had-more {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    gap: 16px;

    svg {
      width: 12px;
      height: 12px;
      fill: var(--black-50);
      transition: transform .3s ease-in-out;
      transform: rotate(-90deg);
    }
  }
}

.custom-menu-popover-class {
  transform: translate(10px, 10px) !important;
  padding: 8px 0 !important;

  .el-popper__arrow {
    display: none !important;
  }

  .el-dropdown-menu__item {
    border-radius: 0 !important;
    padding: 0;
  }

  .status-p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    cursor: pointer;
    width: 100%;
    padding: 8px;

    &:hover {
      background-color: var(--black-10);
      transition: .3s;
    }

    svg {
      width: 12px;
      height: 12px;
      fill: var(--black-50);
      transition: transform .3s ease-in-out;
    }

    &.disabled-status-p {
      opacity: .6;
      cursor: not-allowed;
      pointer-events: none;
    }
  }

}
</style>